import { CheckoutDirectDebitAccountDetails } from '../../models/checkout-payment/checkout-direct-debit-account-details.interface';

export const mockCheckoutDirectDebitAccountDetails: CheckoutDirectDebitAccountDetails =
  {
    sortCode: '205958',
    accountNumber: '88888888',
    accountName: 'accountName',
  };
